var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.ext == 'pdf')?_c('div',[_c('pdf',{staticClass:"pdf-clases",attrs:{"src":_vm.file}})],1):_c('div',[_c('img',{staticClass:"embed-classes",attrs:{"src":_vm.file,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }